import React from "react";
import { useHistory } from "react-router-dom";

import { Box, Typography, Grid, Button } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
export function PageTitle() {
  const history = useHistory();
  return (
    <Grid container direction="row">
      {window.location.href ===
      process.env.REACT_APP_CAREER_BROWSER_DASH_URL ? (
        <> </>
      ) : (
        <Grid item>
          <Button
            variant="outlined"
            className="ml-5 mt-5"
            color="primary"
            onClick={() => {
              history.push("/");

              return false;
            }}
          >
            Back to search
          </Button>
        </Grid>
      )}
      <Grid item xs="12">
        <Box
          display="flex"
          flexDirection="column"
          borderRadius={8}
          alignItems="center"
          width="100%"
          py={2}
        >
          <Typography variant="h3">CAREER INDUSTRIES</Typography>
          <Grid container>
            <Grid item xs={false} md={4}></Grid>
            <Grid item xs={12} md={4}>
              <Box textAlign="center" mt={2}>
                <Typography variant="h5">
                  Select an option below to learn more about the opportunites
                  within it.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={false} md={4}></Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}
